"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getFileSuffix_1 = require("./getFileSuffix");
/**
 * 生成随机的文件名称
 */
function generateRandomFileName(file) {
    return Math.random()
        .toString(36)
        .substring(2) +
        new Date().getTime() +
        getFileSuffix_1.getFileSuffix(file.name);
}
exports.generateRandomFileName = generateRandomFileName;
/**
 * 根据文件信息获得合法的文件名称
 */
function getAttachmentFileName(file) {
    var index = file.name.lastIndexOf('.');
    var name = file.name.substr(0, index);
    // 名称长度截取前20
    var fName = name.slice(0, 20);
    var suffix = getFileSuffix_1.getFileSuffix(file.name);
    // 若filename中带有,，则会使下载失败
    var fileName = fName + suffix;
    fileName = fileName.replace(/,/g, '-');
    return fileName;
}
exports.getAttachmentFileName = getAttachmentFileName;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2VuZXJhdGVOYW1lLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3V0aWxzL2dlbmVyYXRlTmFtZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLGlEQUErQztBQUUvQzs7R0FFRztBQUNILFNBQWdCLHNCQUFzQixDQUFFLElBQVU7SUFDaEQsT0FBTyxJQUFJLENBQUMsTUFBTSxFQUFFO1NBQ2pCLFFBQVEsQ0FBQyxFQUFFLENBQUM7U0FDWixTQUFTLENBQUMsQ0FBQyxDQUFDO1FBQ2IsSUFBSSxJQUFJLEVBQUUsQ0FBQyxPQUFPLEVBQUU7UUFDcEIsNkJBQWEsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUE7QUFDNUIsQ0FBQztBQU5ELHdEQU1DO0FBRUQ7O0dBRUc7QUFDSCxTQUFnQixxQkFBcUIsQ0FBRSxJQUFVO0lBQy9DLElBQU0sS0FBSyxHQUFHLElBQUksQ0FBQyxJQUFJLENBQUMsV0FBVyxDQUFDLEdBQUcsQ0FBQyxDQUFBO0lBQ3hDLElBQU0sSUFBSSxHQUFHLElBQUksQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLENBQUMsRUFBRSxLQUFLLENBQUMsQ0FBQTtJQUN2QyxZQUFZO0lBQ1osSUFBTSxLQUFLLEdBQUcsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDLEVBQUUsRUFBRSxDQUFDLENBQUE7SUFDL0IsSUFBTSxNQUFNLEdBQUcsNkJBQWEsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUE7SUFDdkMsd0JBQXdCO0lBQ3hCLElBQUksUUFBUSxHQUFHLEtBQUssR0FBRyxNQUFNLENBQUE7SUFDN0IsUUFBUSxHQUFHLFFBQVEsQ0FBQyxPQUFPLENBQUMsSUFBSSxFQUFFLEdBQUcsQ0FBQyxDQUFBO0lBQ3RDLE9BQU8sUUFBUSxDQUFBO0FBQ2pCLENBQUM7QUFWRCxzREFVQyJ9